import { Card, Flex, Text } from "@radix-ui/themes";
import { Hourglass } from "lucide-react";
import { TrackManagerApplication } from "@/types/shared";

interface Props {
  /** Every application to this event, already in FIFO order from the server. */
  applications: TrackManagerApplication[];
}

/**
 * Who is in line, and in what order.
 *
 * The order is the promise the waitlist makes — first applied, first promoted
 * when a spot frees — so the positions are numbered rather than left implicit
 * in the row order. The numbering is derived from the serialized order, which
 * is `Application.fifo`; nothing here re-sorts.
 */
export default function WaitlistCard({ applications }: Props) {
  const waitlisted = applications.filter((a) => a.status === "waitlisted");

  if (waitlisted.length === 0) return null;

  return (
    <Card>
      <Flex direction="column" gap="2">
        <Flex align="center" gap="1">
          <Hourglass size={14} />
          <Text size="2" weight="medium">
            Waitlist ({waitlisted.length})
          </Text>
        </Flex>

        <Flex direction="column" gap="1">
          {waitlisted.map((application, index) => (
            <Flex key={application.id} align="baseline" gap="2">
              <Text size="1" color="gray" style={{ minWidth: 20 }}>
                {index + 1}.
              </Text>
              <Flex direction="column">
                <Text size="2">{application.participant.name}</Text>
                <Text size="1" color="gray">
                  Applied {application.created_at}
                </Text>
              </Flex>
            </Flex>
          ))}
        </Flex>

        <Text size="1" color="gray">
          The next eligible applicant is approved automatically when a spot
          frees.
        </Text>
      </Flex>
    </Card>
  );
}
